module.exports = __webpack_public_path__ + "media/xiaoman_03_风景.f91255df.wav";